module.exports = __webpack_public_path__ + "logo-06e733283fa43d1dd57738cfc409adbd.svg";